//获取指定的cookie; 没有则返回空字符串
export let getCookie = function (name = 'tokenManage') {
    let cookieArr = document.cookie.split('; ')
    for (let x = 0; x < cookieArr.length; x++) {
        let arr = cookieArr[x].split('=')
        if (arr[0] == name) return arr[1]
    }
    return '';
}

//删除指定的cookie
export let removeCookie = function (name = 'tokenManage') {
    let date = new Date()
    date.setTime(date.getTime() - 10000)
    document.cookie = name + '=v; expires=' + date.toGMTString();
}

export let getTime = function (type, date = '') {
    let nowDate;
    if (date == '') {
        nowDate = new Date()
    } else if (date != '' && type == 2 && String(date).length != 13) {
        if (date == 'null') return ''
        nowDate = date
    } else if (date != '' && type == 3) {
        if (typeof date == 'string') {
            return date
        }
        nowDate = date
    } else {
        nowDate = new Date(date)
    }
    let year = nowDate.getFullYear(),
        mon = nowDate.getMonth() + 1,
        day = nowDate.getDate(),
        hour = nowDate.getHours(),
        min = nowDate.getMinutes(),
        week = nowDate.getDay()

    if (type == 1) {  //xxxx - xx - xx xx:xx xxx
        let weekFont = ''
        switch (week) {
            case 1:
                weekFont = '星期一'
                break;
            case 2:
                weekFont = '星期二'
                break;
            case 3:
                weekFont = '星期三'
                break;
            case 4:
                weekFont = '星期四'
                break;
            case 5:
                weekFont = '星期五'
                break;
            case 6:
                weekFont = '星期六'
                break;
            default:
                weekFont = '星期天'
                break;
        }
        let str = year + '-' + 
        ((mon < 10) ? 0 + '' + mon : mon) + '-' + 
        ((day < 10) ? 0 + '' + day : day) + ' ' + 
        ((hour < 10) ? 0 + '' + hour : hour) + ':' + 
        ((min < 10) ? 0 + '' + min : min) + ' ' + weekFont
        return str
    } else if (type == 2) {  //xxxx - xx - xx
        let str = year + '-' + 
        ((mon < 10) ? 0 + '' + mon : mon) + '-' + 
        ((day < 10) ? 0 + '' + day : day)
        return str
    } else if (type == 3) {  //xx:xx
        let str = ((hour < 10) ? 0 + '' + hour : hour) + ':' + 
        ((min < 10) ? 0 + '' + min : min)
        return str
    }
}
// export default {
//     getCookie,
//     removeCookie
// }